// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"744b2c90","253":"37de4e70","263":"64ea3a42","352":"765b9bf7","370":"794b2a74","427":"d2e1a00c","508":"4723aa88","614":"a2ea9cac","701":"de9af85c","726":"fa64a33c","758":"1292c319","793":"7b14e51c","971":"5ae13257","978":"6a68eb7e"}[chunkId] + ".chunk.js";
};